import { render } from "./sherkati.vue?vue&type=template&id=56cb1278"
import script from "./sherkati.vue?vue&type=script&lang=js"
export * from "./sherkati.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/zarihi-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__